/**
 * @param {string} provider
 * @param {string | null} appTitle
 * @returns {string}
 */
export function getProviderName(provider, appTitle) {
	if (provider === 'black_knight') {
		return 'Black Knight';
	}

	if (provider === 'quantarium_private_label') {
		return appTitle ?? 'Quantarium Alternate';
	}

	return 'Quantarium';
}

/**
 * @param {number | null | undefined} value
 * @returns {boolean}
 */
export function hasAvmRangeValue(value) {
	return value !== null && value !== undefined;
}
